import React, { useEffect, useRef, memo, useMemo } from 'react';
import './PromoBadge.styles.scss';
import { PromoBadgeProps } from '@/atoms/PromoBadge/PromoBadge.types';

const PromoBadge: React.FC<PromoBadgeProps> = (props: PromoBadgeProps) => {
  const text = useMemo(() => props?.text ?? '', [props?.text]);
  const image = useMemo(() => props?.image ?? '', [props?.image]);
  const textBadgeStyles = useMemo(
    () => ({
      color: props.colors?.foreground,
      backgroundColor: props.colors?.background,
    }),
    [props?.colors]
  );

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!props) return;
    if (!containerRef?.current?.style) return;
    if (!props?.colors?.sideTag) return;

    const sideTag = props.colors.sideTag;
    containerRef.current.style.setProperty('--side-tag-color', sideTag ?? '');
  }, [props?.colors?.sideTag]);

  return (
    <div className="promo-badge promo-badge-component" ref={containerRef}>
      {image ? (
        <img src={image} alt={text} />
      ) : (
        <span
          className="promo-badge-component-text ods-typography-microcopy-bold"
          style={textBadgeStyles}
        >
          {text}
        </span>
      )}
    </div>
  );
};

PromoBadge.displayName = 'PromoBadge';
export default memo(PromoBadge);
